import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ResetPasswordService } from '@app/_services/reset-password.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResetPassword } from '@app/_models/resetPassword';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})

export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  ResetPassword = new ResetPassword();
  ResetEmailId: string;
  submitted = false;
  errorMessage: string;
  returnUrl;
  getresponse: any;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private formBuilder: FormBuilder, private resetPasswordService: ResetPasswordService, private router: Router,
    config: NgbModalConfig,
    private modalService: NgbModal) { }

  get f() { return this.resetForm.controls; }

  ngOnInit(): void {

    this.resetForm = this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });

    const url = window.location.href;
    let emailval;

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      emailval = httpParams.get('emailId');
      // alert("ok...." + emailval);
      this.ResetEmailId = emailval;
    }

  }
  refresh(): void {
    // location.reload();
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.returnUrl = "login";
    this.router.navigate([this.returnUrl]);
  }

  updateResetPassword() {
    //this.modalService.open(this.showModalBoxTemplate);
    this.submitted = true;
    if (this.resetForm.invalid) {
      return;
    }
    this.ResetPassword.username = this.ResetEmailId;
    //  alert("Check Email...."+this.ResetPassword);
    this.errorMessage = "";
    this.resetPasswordService.updateResetPassword(this.ResetPassword)
      .subscribe((response) => {
        if (response) {

          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.modalService.open(this.showModalBoxTemplate);
            // alert("Password Reset Successfully");
            // location.reload();
            //  this.returnUrl = "login";
            //  this.router.navigate([this.returnUrl]);
          }
          else {
            this.errorMessage = this.getresponse.respData;
          }
        }
        else {
          this.errorMessage = "Invalid!!!";
          alert("Password Reset Error Message");
          location.reload();
        }
      },
        (err: any) => {
          this.errorMessage = "Invalid!!!";
          alert("Error Message");
          location.reload();
        });
  }



}
